import React from 'react';
//import PropTypes from 'prop-types';
import { BetFooterContainer, BetRibbon } from './styles';
import Label from '../shared/Label';

const BetFooter = () => (
  <BetFooterContainer>
    <Label
      label="*Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica"
      margin="0px"
      color="betLabel"
      size={0.9}
    />
    <BetRibbon isTitleNarrowMedium>
      <div>18+</div>
    </BetRibbon>
  </BetFooterContainer>
);

BetFooter.propTypes = {
};

export default BetFooter;



// WEBPACK FOOTER //
// ./src/components/BetFooter/index.js